import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const APP_COUNTRY_BLOCKER: DiToken<string[]> = new DiToken<string[]>('appCountryBlocker', {
  factory: () => []
});
